import React, { useEffect, useState } from "react";

export const SplashScreen = ({ onDone }) => {
  const [hiding, setHiding] = useState(false);
  useEffect(() => {
    const t1 = setTimeout(() => setHiding(true), 1400);
    const t2 = setTimeout(onDone, 1950);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [onDone]);
  return (
    <div
      data-testid="splash-screen"
      className={`fixed inset-0 z-[9999] flex items-center justify-center bg-black splash-overlay ${hiding ? "splash-hide" : ""}`}
    >
      <img src="/logo-fripri-splash.svg" alt="Fripri" className="w-64 max-w-[70vw] splash-logo" />
    </div>
  );
};

export default SplashScreen;
